// extracted by mini-css-extract-plugin
export default {"component_container":"AdminBody_component_container__3m5uL"};